import React from 'react';
import classNames from 'classnames';
import styles from '../assets/providers-grid.module.scss';
import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from 'src/components/react-table/Grid';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import textFilter from 'src/components/react-table/filters/text-filter';
import { QueryParams } from 'src/types/grid';
import { IProvider } from 'src/types/provider';
import ProviderActionsColumn from './ProviderActionsColumn';
import ProviderDetailColumn from './ProviderDetailColumn';
import ProviderStatusColumn from './ProviderStatusColumn';
import { CellProps } from 'react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { changeToZeroMoment } from '../../../../../../../helpers/timeHelpers';
import dropdownFilter from '../../../../../../../components/react-table/filters/dropdown-filter';
import GeneralEnum from '../../../../../../../enumerables/general-enum';
import { getValFromEnum } from '../../../../../../../components/redux-form/utils/dropdown-values';
import Router from '../../../../../../../navigation/router';
import { routes } from '../../../../../../../navigation';

interface Props {
    data: Paginated<Partial<IProvider>>;
    getData: (params: QueryParams) => void;
}

const ProviderFilterStatus = GeneralEnum ? GeneralEnum.getEnum('UserStatus') : {};

const statusFilterValues: SelectObject[] = getValFromEnum(ProviderFilterStatus);

statusFilterValues.pop();

const columns: Column<Partial<IProvider>>[] = [
    {
        Header: 'Name',
        accessor: 'fullName',
        Cell: ProviderDetailColumn,
        Filter: textFilter<IProvider>(),
    },
    {
        Header: 'Email',
        accessor: 'email',
        Filter: textFilter<IProvider>(),
    },
    {
        Header: 'Phone',
        accessor: 'phone',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IProvider>) => {
            return (
                <a rel="noopener noreferrer" target="_blank" href={`tel:${original.phone}`}>
                    {original.phone}
                </a>
            );
        },
        Filter: textFilter<IProvider>(),
        disableSortBy: true,
        width: '10%',
    },
    {
        Header: 'Supervisor',
        accessor: 'supervisor',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IProvider>) => {
            let name = '';
            let url = '';
            const sups: any = [];
            original.supervisor?.forEach((s: any) => {
                name = s.fullName;
                url = Router.generate(routes.PROVIDER_DETAIL, { id: s.id, tab: 'main-info', subId: '' });
                sups.push(name);
            });
            return <div>{sups.join(', ')}</div>;
        },
        disableSortBy: true,
        Filter: textFilter<IProvider>(),
    },
    {
        Header: 'NPI',
        accessor: 'npi',
        Filter: textFilter<IProvider>(),
        disableSortBy: true,
    },
    {
        Header: 'License',
        accessor: 'license',
        Filter: textFilter<IProvider>(),
        disableSortBy: true,
    },

    {
        Header: 'Advance',
        accessor: 'isGetAdvance',
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IProvider>) => (original.isGetAdvance ? <FontAwesomeIcon icon={faCheck} /> : null),
        disableSortBy: true,
    },

    {
        Header: 'Created',
        accessor: 'createdAt',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IProvider>) => {
            return changeToZeroMoment(original.createdAt, 'MMM D, YYYY');
        },
        disableFilters: true,
    },
    {
        Header: 'Status',
        accessor: 'status',
        disableSortBy: true,
        Filter: dropdownFilter<IProvider>(statusFilterValues, styles.minWidth),
        width: '10%',
        Cell: ProviderStatusColumn,
    },
    {
        Header: 'Actions',
        accessor: 'id',
        Cell: ProviderActionsColumn,
        disableSortBy: true,
        disableFilters: true,
    },
];

const ProvidersGrid: React.FunctionComponent<Props> = ({ data, getData }: Props) => {
    const filtersInit: any[] = [];
    filtersInit.push({ id: 'status', value: 1 });

    return (
        <div className={classNames(styles.grid)}>
            <Grid<Partial<IProvider>> filtersInit={filtersInit} columns={columns} data={data} getData={getData} />
        </div>
    );
};

export default ProvidersGrid;
